import { Pill } from '@/components/shared/components/Pill';
import styled from '@emotion/styled';
import { rem, TextAreaV2 } from '@triumph/design-system';

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
`;

export const DropdownWrapper = styled.div`
    width: 50%;
`;

export const StatusSelectWrapper = styled(DropdownWrapper)`
    label {
        padding-left: 0;
    }

    select {
        padding-left: 0;
    }
`;

export const CompactFieldLabel = styled.label`
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: ${rem(11)};
    font-weight: 600;
    color: #6b7280;
    text-align: left;
`;

export const CompactFieldValue = styled.div`
    font-size: ${rem(13)};
    color: #111827;
    text-align: left;
`;

export const MessageToApplicantTextArea = styled(TextAreaV2)`
    textarea {
        height: auto;
    }
`;

export const ConditionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: ${rem(12)};
    width: 100%;
    text-align: left;

    /* Make the inline Add Task/Condition textarea vertically resizable, scoped
       to this modal so the shared LinkifyTextarea stays fixed-height elsewhere. */
    [role='textbox'] {
        resize: vertical;
    }
`;

export const OpenConditionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(6)};
    width: 100%;
`;

export const DecisionErrorBanner = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(4)};
    padding: ${rem(10)} ${rem(12)};
    border-radius: ${rem(6)};
    background: #fef3c7;
    border: ${rem(1)} solid #fde68a;
    color: #92400e;
    font-size: ${rem(13)};
    font-weight: 600;
    width: 100%;
    text-align: left;
`;

export const AddConditionButtonRow = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const SectionDivider = styled.hr`
    width: 60%;
    border: none;
    border-top: 1px solid #d1d5db;
    margin: ${rem(4)} auto;
`;

export const OpenConditionsTitle = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(8)};
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: ${rem(11)};
    font-weight: 600;
    color: #6b7280;
`;

export const OpenConditionRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(10)};
    padding: ${rem(8)} ${rem(10)};
    border: 1px solid #e5e7eb;
    border-radius: ${rem(6)};
    background: #ffffff;
`;

export const OpenConditionBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(2)};
    flex: 1;
    min-width: 0;
`;

export const OpenConditionDescription = styled.div`
    font-weight: 600;
    color: #111827;
    font-size: ${rem(13)};
    line-height: 1.4;
    white-space: pre-line;
`;

export const OpenConditionMeta = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(6)};
    flex-wrap: wrap;
    font-size: ${rem(11)};
    color: #9ca3af;
`;

export const OpenConditionProductPill = Pill;

export const ProductRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(16)};
`;

export const EmailPreviewHeaders = styled.div`
    h3 {
        font-size: ${rem(16)};
        font-weight: ${({ theme }) => theme.typography.fontWeights.semiBold};
        margin: 0;
        text-align: left;

        & > span {
            font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
        }
    }
`;

export const EmailPreviewBody = styled.div`
    & > div {
        padding-left: ${rem(15)};
        padding-right: ${rem(15)};
    }
`;

export const PendingRequestBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: hsl(48 100% 80% / 1);
    color: black;
    border-radius: ${rem(10)};
    min-width: ${rem(18)};
    height: ${rem(18)};
    font-size: ${rem(11)};
    font-weight: 600;
    padding: 0 ${rem(5)};
    margin-left: ${rem(4)};
    line-height: 1;
    vertical-align: middle;
`;

export const StatusInfoButton = styled.button`
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
`;

export const StatusInfoModalHeader = styled.h2`
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    font-size: ${rem(22)};
    margin-top: 0;
    margin-bottom: ${rem(12)};
    line-height: 1.2;
`;

export const StatusInfoModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(6)};
`;

export const StatusInfoModalRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: ${rem(6)};
    line-height: 1.4;
`;

export const StatusInfoModalDescription = styled.p`
    margin: 0;
    line-height: 1.4;
    text-align: left;
    white-space: pre-wrap;
`;

export const DenialFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(12)};
`;

export const ViewRequestModalCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(6)};
    padding: ${rem(12)};
    background: hsl(48 100% 96% / 1);
    border: 1px solid hsl(48 100% 70% / 0.5);
    border-radius: 6px;
`;

export const ViewRequestModalProductTag = styled.span`
    background: hsl(48 100% 80% / 1);
    color: black;
    border-radius: ${rem(10)};
    padding: 1px 8px;
    font-size: ${rem(11)};
    font-weight: 600;
`;

export const ViewRequestModalMessage = styled.p`
    margin: 0;
    font-size: ${rem(13)};
    line-height: 1.5;
    white-space: pre-wrap;
    color: #0a1e3a;
    text-align: left;
`;
